import React from "react";

const Second_Answer = () => {
  return (
    <>
      <div className="second_answer">
        <p>
          The International Education Awards have been instituted by TIME CYBER
          MEDIA PRIVATE LIMITED to recognize individuals and educational
          institutions that have made significant contributions to the education
          sector, including schools, institutes, colleges, universities, and
          other educational organizations. Educators who have contributed to the
          education community will also be recognized for their efforts. The
          awards aim to highlight and appreciate the dedication and hard work of
          those who have improved the quality of education and made a positive
          impact on society.
          <br />
          operating from the National Capital New Delhi.
        </p>
      </div>
    </>
  );
};

export default Second_Answer;
